import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["announcementId"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from 'react-query';
import api from 'utils/api';
import { announcementQueryKeys } from 'actions/announcements';
function useUpdateUserAnnouncementState(_ref) {
  var announcementId = _ref.announcementId,
    options = _objectWithoutProperties(_ref, _excluded);
  var queryClient = useQueryClient();
  function updateUserAnnouncementState(_x) {
    return _updateUserAnnouncementState.apply(this, arguments);
  }
  function _updateUserAnnouncementState() {
    _updateUserAnnouncementState = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(announcementData) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('post', '/api/query/userAnnouncement', {
              id: announcementId
            }, _objectSpread({
              announcement_id: announcementId
            }, announcementData)));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateUserAnnouncementState.apply(this, arguments);
  }
  var _useMutation = useMutation(updateUserAnnouncementState, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess(data, announcementData) {
        // If announcement is read, we want to wait for invalidation until the modal is closed
        // so the next announcement is not triggered
        if (announcementData.is_dismissed) {
          queryClient.invalidateQueries(announcementQueryKeys.announcements);
        }
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    queryOptions = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, queryOptions), {}, {
    updateUserAnnouncementState: mutateAsync
  });
}
export default useUpdateUserAnnouncementState;